<template>
    <span
        v-show="!finished || (finished && finishedMessage.length > 0)"
        :class="{ countdown: !plainText }"
    >
        <span v-if="finished">{{ finishedMessage }}</span>
        <span v-else>
            <span v-if="caption">{{ `${caption} ` }}</span>
            <span v-if="days > 0">
                <span :class="{ number: !plainText }"
                    >{{ days.toString().padStart(3, ' ') }}&nbsp;</span
                >
                <span v-if="days === 1">{{ `${$t('shared.countdown.day')} ` }}</span>
                <span v-else>{{ `${$t('shared.countdown.days')} ` }}</span>
            </span>
            <span v-if="days > 0 || hours > 0">
                <span :class="{ number: !plainText }"
                    >{{ hours.toString().padStart(2, ' ') }}&nbsp;</span
                >
                <span v-if="hours === 1">{{ `${$t('shared.countdown.hour')} ` }}</span>
                <span v-else>{{ `${$t('shared.countdown.hours')} ` }}</span>
            </span>
            <span v-if="days > 0 || hours > 0 || minutes > 0">
                <span :class="{ number: !plainText }"
                    >{{ minutes.toString().padStart(2, ' ') }}&nbsp;</span
                >
                <span v-if="minutes === 1">{{ `${$t('shared.countdown.minute')} ` }}</span>
                <span v-else>{{ `${$t('shared.countdown.minutes')} ` }}</span>
            </span>
            <span v-if="showSeconds">
                <span :class="{ number: !plainText }"
                    >{{ seconds.toString().padStart(2, ' ') }}&nbsp;</span
                >
                <span v-if="seconds === 1">{{ $t('shared.countdown.second') }}</span>
                <span v-else>{{ $t('shared.countdown.seconds') }}</span>
            </span>
        </span>
    </span>
</template>

<script>
export default {
    name: 'Countdown',
    props: {
        plainText: {
            type: Boolean,
            default: false,
        },
        caption: {
            type: String,
            default: '',
        },
        timestamp: {
            type: Date,
            default: () => {
                return new Date(Date.now() - 2);
            },
        },
        finishedMessage: {
            type: String,
            default: () => '',
        },
    },
    data() {
        return {
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
            finished: false,
            interval: null,
        };
    },
    computed: {
        showSeconds() {
            return this.days === 0 && this.hours === 0;
        },
    },
    methods: {
        timerTick() {
            const now = new Date(Date.now());
            const diff = this.timestamp - now;

            if (diff < 0) {
                this.finished = true;
            } else {
                this.finished = false;
                this.days = Math.floor(diff / (3600 * 24 * 1000));
                let rem = diff - this.days * (3600 * 24 * 1000);
                this.hours = Math.floor(rem / (3600 * 1000));
                rem -= this.hours * 3600 * 1000;
                this.minutes = Math.floor(rem / (60 * 1000));
                rem -= this.minutes * 60 * 1000;
                this.seconds = Math.floor(rem / 1000);
            }
        },
    },
    watch: {
        timestamp() {
            this.timerTick();
        },
    },
    mounted() {
        this.timerTick();
        this.interval = setInterval(this.timerTick, 1000);
    },
    beforeDestroy() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
        }
    },
};
</script>

<style scoped>
.countdown {
    background: var(--primary);
    color: #fff;
    padding: 10px 20px 10px 20px;
    border-radius: 5px;
    z-index: 100;
    font-size: 0.9em;
    white-space: nowrap;
}

.number {
    font-size: 1.3em;
    font-weight: 500;
}

@media only screen and (max-width: 600px) {
    .countdown {
        font-size: 0.5em;
    }
}
</style>
